/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AgentShoppingConsultantInternalService } from './services/AgentShoppingConsultantInternalService';
import { AgentShoppingConsultantService } from './services/AgentShoppingConsultantService';
import { DefaultService } from './services/DefaultService';
import { DiscoveryEvaluationEvalSetService } from './services/DiscoveryEvaluationEvalSetService';
import { DiscoveryEvaluationRunsService } from './services/DiscoveryEvaluationRunsService';
import { DiscoveryEvaluationService } from './services/DiscoveryEvaluationService';
import { DiscoveryEvaluationSolutionRequestsService } from './services/DiscoveryEvaluationSolutionRequestsService';
import { DiscoveryService } from './services/DiscoveryService';
import { InputsService } from './services/InputsService';
import { SolutionsService } from './services/SolutionsService';
import { SubjectsService } from './services/SubjectsService';
import { TestingService } from './services/TestingService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ZorroPyClient {
  public readonly agentShoppingConsultant: AgentShoppingConsultantService;
  public readonly agentShoppingConsultantInternal: AgentShoppingConsultantInternalService;
  public readonly default: DefaultService;
  public readonly discovery: DiscoveryService;
  public readonly discoveryEvaluation: DiscoveryEvaluationService;
  public readonly discoveryEvaluationEvalSet: DiscoveryEvaluationEvalSetService;
  public readonly discoveryEvaluationRuns: DiscoveryEvaluationRunsService;
  public readonly discoveryEvaluationSolutionRequests: DiscoveryEvaluationSolutionRequestsService;
  public readonly inputs: InputsService;
  public readonly solutions: SolutionsService;
  public readonly subjects: SubjectsService;
  public readonly testing: TestingService;
  public readonly request: BaseHttpRequest;
  constructor(
    config?: Partial<OpenAPIConfig>,
    HttpRequest: HttpRequestConstructor = AxiosHttpRequest
  ) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? '',
      VERSION: config?.VERSION ?? '0.1.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.agentShoppingConsultant = new AgentShoppingConsultantService(
      this.request
    );
    this.agentShoppingConsultantInternal =
      new AgentShoppingConsultantInternalService(this.request);
    this.default = new DefaultService(this.request);
    this.discovery = new DiscoveryService(this.request);
    this.discoveryEvaluation = new DiscoveryEvaluationService(this.request);
    this.discoveryEvaluationEvalSet = new DiscoveryEvaluationEvalSetService(
      this.request
    );
    this.discoveryEvaluationRuns = new DiscoveryEvaluationRunsService(
      this.request
    );
    this.discoveryEvaluationSolutionRequests =
      new DiscoveryEvaluationSolutionRequestsService(this.request);
    this.inputs = new InputsService(this.request);
    this.solutions = new SolutionsService(this.request);
    this.subjects = new SubjectsService(this.request);
    this.testing = new TestingService(this.request);
  }
}
